import { useQuery } from '@tanstack/react-query';
import { loadResolver } from '@/lib/nomenclature/resolver';

export const resolverQueryKey = ['nomenclature', 'resolver'] as const;

/**
 * Loads the reverse nomenclature resolver (UUID → names) from IndexedDB.
 *
 * The cache usually already holds the previous session's data, so the resolver
 * is ready on first render; after a fresh sync we invalidate this query (see
 * `useNomenclatureSync`) so newly-synced names appear.
 */
export function useResolver() {
  return useQuery({
    queryKey: resolverQueryKey,
    queryFn: loadResolver,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
  });
}
